import { PermissionType } from "@store/session/types";
import { API } from "aws-amplify";

async function listPermissionsForSite(userId: string, companyId: string, siteId: string): Promise<{ kvsName: string, permissions: PermissionType[]}[]> {
  try {
    const path: string = `/permissions/${userId}/${companyId}/${siteId}`;
    const service: string = `api-service`;
    
    const data = await API.get(
      service,
      path,
      {}
    );

    const result = Object.keys(data.data).map((key) => {
      return {
        kvsName: key,
        permissions: data.data[key]
      }
    })

    return result;
  } catch (error: any) {
    throw error;
  }
}

export default listPermissionsForSite;
